module.exports = __webpack_public_path__ + "static/img/wd-chat.2e92322.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/wd-chat.svg
// module id = ReHo
// module chunks = 26